import React from "react";
import AddStationContainer from "containers/AddStation";

const AddStation = (props) => {
  return (
    <AddStationContainer {...props}/>
  );
};

export default AddStation;
